export default __webpack_public_path__ + "static/media/loserGif.1acad697.gif";